import 'styles/Gallery.less'
import 'styles/PhotoFeed.less'
import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames/bind'
import { connect } from 'react-redux'
import assets from 'modules/assets'
import Loading from 'components/Utils/Loading'


class Image extends Component {
  static loadType = {
    SIMPLE: 'simple',
    GREY: 'grey',
    BLUR: 'blur',
    LOADER: 'loader'
  }
  constructor(props) {
    super(props)
    let transitionTime = 150
    if (props.transitionTime)
      transitionTime = props.transitionTime
    this.state = {
      opacity: 0,
      height: 0,
      width: 0,
      transitionTime: transitionTime
    }
    this.onImageLoad = this.onImageLoad.bind(this)
    this.startShowingImage = this.startShowingImage.bind(this)
    this.increaseOpacity = this.increaseOpacity.bind(this)
    this.timeOut = null
    this.timeLeft = this.state.transitionTime
    this.timeIncrement = 30
  }

  increaseOpacity() {
      if (!this._mounted)
        return

      let opacity = this.state.opacity
      //console.log(this.timeLeft)
      this.timeLeft -= this.timeIncrement
      this.setState({
        opacity: 1 - (this.timeLeft / this.state.transitionTime)
      })
      if (this.timeLeft > 0)
        setTimeout(this.increaseOpacity, this.timeIncrement)
  }

  startShowingImage() {
    if (!this._mounted)
      return
    if (this.timeLeft <= 0)
      return

    setTimeout(this.increaseOpacity, this.state.timeIncrement)
  }

  onImageLoad() {
    if (!this._mounted)
      return

    setTimeout(() => {
    this.startShowingImage()
    if (this.props.imageLoadedHandler != null)
      this.props.imageLoadedHandler()
    }, 0)

  }

  componentWillReceiveProps(newProps) {
    let transitionTime = 150
    if (this.props.transitionTime)
      transitionTime = this.props.transitionTime

    if (newProps.photo.url != this.props.photo.url || this.props.style != newProps.style) {
      this.setState({
        opacity: 0,
        transitionTime: transitionTime
      })
      this.timeLeft = this.state.transitionTime
    } else if (this.state.width != newProps.width || this.state.height != newProps.height) {
      this.setState({
        height: newProps.height,
        width: newProps.width
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.photo.url != this.props.photo.url || nextProps.style != this.props.style || nextState.opacity != this.state.opacity) {
      return true
    }
    return false
  }

  componentDidUpdate() {
    if (this.state.opacity == 0) {
      var imgTag = ReactDOM.findDOMNode(this.refs.img)
      var imgSrc = imgTag.getAttribute('src')
      var img = new window.Image()
      img.onload = this.onImageLoad
      img.src = imgSrc
    }
  }

  getImageSrc() {
    if (!this.props.highRes) {
      return this.props.photo.thumb
    } else {
      return this.props.photo.url
    }
  }

  componentDidMount() {
    var imgTag = ReactDOM.findDOMNode(this.refs.img)
    var imgSrc = this.getImageSrc()
    var imgContainer = ReactDOM.findDOMNode(this.refs.container)
    let elWidth = Math.max(imgContainer.clientWidth, imgContainer.innerWidth)
    let height = elWidth * this.props.photo.imgSize.height / this.props.photo.imgSize.width
    imgContainer.style.height = height

    var img = new window.Image()
    img.onload = this.onImageLoad
    img.src = imgSrc
    this._mounted = true
  }

  componentWillUnmount() {
    if (this.timeOut != null)
      clearTimeout(this.timeOut)
    this._mounted = false
  }

  getGradualBlurLoading(rootClassName, style) {
    var displayLowRes = (this.state.opacity == 0)
    var imgStyle = {
      width: '100%',
      opacity: this.state.opacity,
      display: (displayLowRes ? 'none' : 'block')
    }

    var lowResImgStyle = {
      width: '100%',
      display: (!displayLowRes ? 'none' : 'block'),
      filter: 'blur(20px) opacity(0.90) saturate(.75) sepia(.22)'
    }

    //console.log({...props})

    return (
      <div ref="container" className={rootClassName} style={style} onClick={this.props.onClick}>
        <img ref="img2" src={this.props.photo.preview} style={lowResImgStyle}/>
        <img ref="img" src={this.getImageSrc()} style={imgStyle}/>
      </div>
    )
  }

  getLoaderLoading(rootClassName, style) {
    style.backgroundColor = 'inherit'
    var displayLoader = (this.state.opacity == 0)
    var imgStyle = {
      width: '100%',
      opacity: this.state.opacity,
      display: (displayLoader ? 'none' : 'block')
    }

    var loaderStyle = {
      width: '100%',
      display: (!displayLoader ? 'none' : 'block')
    }

    //console.log({...props})

    return (
      <div ref="container" className={rootClassName} style={style} onClick={this.props.onClick}>
        <Loading style={loaderStyle}/>
        <img ref="img" src={this.getImageSrc()} style={imgStyle}/>
      </div>
    )
  }

  getGradualGreyLoading(rootClassName, style) {
    var imgStyle = {
      width: '100%',
      opacity: this.state.opacity
    }

    return (
      <div ref="container" className={rootClassName} style={style} onClick={this.props.onClick}>
        <img ref="img" src={this.getImageSrc()} style={imgStyle}/>
      </div>
    )
  }

  getNonGradualLoading(rootClassName, style) {
    style.backgroundColor = 'inherit'
    return (this.getGradualGreyLoading(rootClassName, style))
  }

  render() {
    //console.log(this.props.photo)
    var { className, imageLoadedHandler, photo, ...props } = this.props
    var imgClasses = 'image'
    var rootClassName = classNames(className, imgClasses, {'image-loaded': this.state.opacity > 0})
    if (this.props.style != null)
      var style = Object.assign({}, this.props.style)
    else
      var style = {}

    if (!this.props.typeOfLoading) {
      return (this.getGradualBlurLoading(rootClassName, style))
    }
    if (this.props.typeOfLoading == Image.loadType.BLUR) {
      return (this.getGradualBlurLoading(rootClassName, style))
    } else if (this.props.typeOfLoading == Image.loadType.GREY) {
      return (this.getGradualGreyLoading(rootClassName, style))
    } else if (this.props.typeOfLoading == Image.loadType.SIMPLE) {
      return (this.getNonGradualLoading(rootClassName, style))
    } else if (this.props.typeOfLoading == Image.loadType.LOADER) {
      return (this.getLoaderLoading(rootClassName, style))
    } else {
      return (this.getGradualBlurLoading(rootClassName, style))
    }

	}
}

Image.contextTypes = {
}
Image.propTypes = {
}

export default Image



// WEBPACK FOOTER //
// ./src/components/Gallery/Image.js